import { useTranslation } from 'react-i18next';
import Dialog from '../../../../../../common/widgets/Dialog';
import Icons from '../../../../../../common/widgets/Icons';
import { resources } from '../../../../resources/resources';

interface DeleteAccountDialogProps {
  closeDialog: () => void;
}

export const DeleteAccountDialog = (props: DeleteAccountDialogProps) => {
  const { closeDialog } = props;
  const { t: translate } = useTranslation();

  return (
    <Dialog
      closeDialog={closeDialog}
      closeOnClickOutside
      showCloseIcon
      className="dialog-l"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <Icons.HelpRed />
        </div>
        <div className="dialog-title">
          {translate(resources.accountInfo.delete.dialog.title)}
        </div>
        {translate(resources.accountInfo.delete.dialog.body)}{' '}
        <span
          className="delete-account-link"
          onClick={() =>
            window.open(translate(resources.accountInfo.delete.dialog.formLink))
          }
        >
          {translate(resources.accountInfo.delete.dialog.formLabel)}
        </span>
      </div>
    </Dialog>
  );
};
